export default function getScrollbarWidth() {
  const outer = document.createElement('div')
  outer.style.visibility = 'hidden'
  outer.style.overflow = 'scroll' // This creates a scrollbar
  outer.style.width = '50px'
  outer.style.height = '50px'

  document.body.appendChild(outer)

  const inner = document.createElement('div')
  inner.style.width = '100%'
  inner.style.height = '100%'

  outer.appendChild(inner)

  var scrollbarWidth = outer.offsetWidth - inner.offsetWidth

  document.body.removeChild(outer)

  return scrollbarWidth
}
